// frontend/src/components/HeorSection.jsx
import React from 'react';

export default function HeroSection() {
  return (
    <section className="p-8 text-center" style={{ backgroundColor: '#CCC9AF' }}>
      <h1 className="text-3xl md:text-5xl font-bold mb-4">
        Elevate your Enterprise with AquaMind AI Solutions
      </h1>
      <p className="text-lg mb-6">
        Harness the power of cutting-edge AI to transform your business operations, enhance decision-making, and drive unprecedented growth.
      </p>
      <a
        href="#contact"
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
      >
        Discover AI Solutions
      </a>
    </section>
  );
}

